import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AxiosMahasiswa = () => {
    const url = "https://backendexample.sanbercloud.com"
    const [mahasiswa, setMahasiswa] = useState([]);
    const [inputNama, setInputNama] = useState([]);
    const [inputMatkul, setInputMatkul] = useState()
    const [inputNilai, setInputNilai] = useState()
    // const [currentId, setCurrentId] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [statusForm, setStatusForm] = useState("create")
    const [currentIndex, setCurrentIndex] = useState(-1)

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios.get(`${url}/api/student-scores`)

            setMahasiswa(result.data.map(x=>{return {id: x.id, name: x.name, course: x.course, score: x.score,
            index: x.score}}))
        }
        fetchData()
    }, [])

    const addNewDataMhs = () => {
        setInputNama()
        setInputMatkul()
        setInputNilai()
        setShowForm(true)
        setStatusForm("create")
    }

    const handleSubmit = (event) =>{
        event.preventDefault()
        if (currentIndex === -1){
            axios.post(`${url}/api/student-scores`, {name: inputNama, course: inputMatkul, score: inputNilai}).then(res=>{
                let data = res.data
                setMahasiswa([...mahasiswa, {name: data.name, course: data.course, score: data.score}])
            })
        } else {
            axios.put(`${url}/api/student-scores/${currentIndex}`, {name: inputNama, course: inputMatkul, score: inputNilai}).then(()=>{
                let singleMahasiswa = mahasiswa.find((item) => item.id === currentIndex)
                singleMahasiswa.name = inputNama
                singleMahasiswa.course = inputMatkul
                singleMahasiswa.score = inputNilai
                setMahasiswa([...mahasiswa])
            })
        }

        setCurrentIndex(-1)
        setInputNama()
        setInputMatkul()
        setInputNilai()
        setShowForm(false)
    }

    const handleEdit = async (event) =>{
        let idMhs = Number(event.target.value)
        let id = mahasiswa[idMhs].id
        // axios.put(`${url}/api/student-scores/${id}`)
        // console.log(id)

        let result = await axios.get(`${url}/api/student-scores/${id}`)
        let currentMhs = result.data
        setStatusForm("edit")
        setShowForm(true)
        setCurrentIndex(id)
        setInputNama(currentMhs.name)
        setInputMatkul(currentMhs.course)
        setInputNilai(currentMhs.score)
      }
    
      const handleDelete = (event) =>{
        let idPeserta = parseInt(event.target.value)
        let id = mahasiswa[idPeserta].id
        axios.delete(`${url}/api/student-scores/${id}`)
        .then((res) => {
          setMahasiswa(mahasiswa.filter((x)=> x.id !== id))
        }).catch((err)=>{
            console.log(err)
        })
      }

    const handleNama = (event) => {
        let value = event.target.value
        setInputNama(value)
    }

    const handleMatkul = (event) => {
        let value = event.target.value
        setInputMatkul(value)
    }

    const handleNilai = (event) => {
        let value = event.target.value
        setInputNilai(value)
    }
    
    return(
        <>
            {mahasiswa !== null && 
            (
                <div className='App'>
                    <h1 className='App'>Daftar Nilai Mahasiswa</h1>
                    <table className='custom-table'>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Nama</th>
                                <th>Mata Kuliah</th>
                                <th>Nilai</th>
                                <th>Index Nilai</th>
                                <th>Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mahasiswa.map ((item, index) =>{
                                function indexNilai(n){
                                    if (n >= 80){
                                        var index = "A";
                                        return index;
                                    } else if (n >= 70 && n < 80){
                                        index = "B";
                                        return index;
                                    } else if (n >= 60 && n < 70){
                                        index = "C";
                                        return index;
                                    } else if (n >= 50 && n < 60){
                                        index = "D";
                                        return index;
                                    } else {
                                        index = "E";
                                        return index;
                                    }

                                } 
                                return(
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.course}</td>
                                        <td>{item.score}</td>
                                        <td>{indexNilai(item.score)}</td>
                                        <td>
                                        <button className="button-edit mr-10" onClick={handleEdit} value={index}>Edit</button>
                                        <button className="button-delete" onClick={handleDelete} value={index}>Delete</button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {!showForm && <button className='button-add' onClick={addNewDataMhs}> Tambah Data Mahasiswa</button>}
        {showForm && (
            <>
                <h1 className='App'>{statusForm === "create" ? "Tambah Data Mahasiswa Baru" : `Edit Data Mahasiswa`}</h1>
                <div className='custom-form'>
                    <form onSubmit={handleSubmit}>
                        <div className='custom-input'>
                            <label htmlFor='name'>Nama :</label>
                            <input required autoComplete='off' type="text" name='name' value={inputNama} onChange={handleNama} placeholder="Masukkan Nama..." /> 
                            <label htmlFor='harga'>Mata Kuliah :</label>
                            <input required autoComplete='off' type="text" name='course' value={inputMatkul} onChange={handleMatkul} placeholder="Masukkan Mata Kuliah..." /> 
                            <label htmlFor='berat'>Nilai :</label>
                            <input required autoComplete='off' type="number" max="100" name='score' value={inputNilai} onChange={handleNilai} placeholder="Masukkan Nilai..." /> 
                        </div>
                        <input type="submit" value="Submit"/>
                    </form>
                </div>
            </>
        )}
                    
        </div>
                
            )}
            
        </>
    )

}

export default AxiosMahasiswa;